import { QueryClient } from '@tanstack/react-query'

// App-wide default QueryClient for @tanstack/react-query consumers (e.g.
// shared/ui/avatar.tsx) that don't live under one of the page-local
// QueryClientProviders (browse-entry, editor-console, tag-manager,
// contribute, questionnaire, visualize) -- those keep their own
// purpose-tuned clients; a nested QueryClientProvider always takes
// precedence over this root one for its own subtree, so mounting this
// alongside them is additive, not a conflict.
export const queryClient = new QueryClient()
